import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// Coffee Run Frontend Entry Point - Original Implementation
// TODO: Configure MSAL provider for Azure AD authentication

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* TODO: Wrap with Coffee Run MSAL provider */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
